import React from 'react'
import "./Loder.css"

const PaymentLoader = () => {
    return (
        <>
            <div className="loader">
                <div className="loader-image-div">
                    <img src="assets/loader.gif" alt="loder2" />
                </div>
                <p>Payment is processing...</p>
            </div>
        </>
    )
}

export default PaymentLoader
